import React from "react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import {
  WalletScreenRoute,
  UploadFileScreenRoute,
  PassportFileShareScreenRoute,
} from "./routes";
import WalletScreen from "../../screens/WalletScreen/WalletScreen";
import UploadFileScreen from "../../screens/UploadFile/UploadFile";
import PassportFileShareScreen from "../../screens/ShareScreen/PassportFileShareScreen";
import { ImageReceived } from "../../../App";

export type WalletStackParams = {
  [WalletScreenRoute]: undefined;
  [UploadFileScreenRoute]: undefined | { image: ImageReceived };
  [PassportFileShareScreenRoute]: undefined;
};

const { Navigator, Screen } = createNativeStackNavigator<WalletStackParams>();

const WalletStack = () => {
  return (
    <Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <Screen name={WalletScreenRoute} component={WalletScreen} />
      <Screen
        name={PassportFileShareScreenRoute}
        component={PassportFileShareScreen}
      />
      <Screen name={UploadFileScreenRoute} component={UploadFileScreen} />
    </Navigator>
  );
};

export default WalletStack;
